import { useLocation, useParams } from "react-router-dom";
import { matchPath } from "react-router";
import { NetworkRouteProps } from "../@types";
import { NETWORK_ROUTES } from "../consts";
import { removeSurroundingQuotes } from "../util";

/**
 * Gets current route name and value. (used on NTI screen)
 */
export const useNetworkRoute = ({
  removeQuotes = true
}: NetworkRouteProps = {}) => {
  const location = useLocation();
  const params = useParams();
  const activeRoute = NETWORK_ROUTES.find(route =>
    matchPath({ path: route.path }, location.pathname)
  );

  if (!activeRoute) return ["", ""];
  const selectedRouteName = activeRoute.name;
  const selectedRouteValue = removeQuotes
    ? removeSurroundingQuotes(params?.[selectedRouteName] || "")
    : params?.[selectedRouteName];
  return [selectedRouteName, selectedRouteValue];
};
